import * as React from 'react';
import { createComponent } from '@lit-labs/react';
import { ClbTableFooter } from '@celebration/design-system/dist/lib/table-footer';

export default createComponent({
    react: React,
    elementClass: ClbTableFooter,
    tagName: ClbTableFooter.tagName,
    events: ClbTableFooter.events,
});

export const TableFooterSlots = ClbTableFooter.slots;
